import React from "react";
import Header from "./Header";
import { Container } from "reactstrap";

const Layout = ({ children }) => (
    <div className="app-wrapper">
        <div className="app-main">
            {/* <Header /> */}
            <div className="app-content">
                {children}
            </div>
        </div>
    </div >
);

export default Layout;
